// extracted by mini-css-extract-plugin
export var infoRow = "_o3-2";
export var labelContainer = "_o3-0";
export var rightInfo = "_o3-1";